import { PricingOffer } from './models/pricing-offer.model';

export const PRICING_API_ACCEPT_VERSION = '3.0.0';

export enum OfferCtaTypesEnum {
  primary = 'primary',
  secondary = 'secondary',
}

export enum OfferTypesEnum {
  cancellation_winback = 'cancellation_winback',
}

export interface IOfferData {
  [offerType: string]: PricingOffer;
}
